import { OriginInfo } from "@/types";
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";

export type TrainStationCountryCode = "UK" | "FR" | "NL" | "BE" | "NL_EUROSTAR" | "BE_EUROSTAR"

export const trainStationsByCountry: Record<TrainStationCountryCode, Array<[string, OriginInfo]>> = {
	// We don't use anymore property "name", we use the content translation from ssr (ie planning_traintimeline_station_PLY)
	UK: [
		["STP", { name: "London Saint Pancras" }] 
	],
	FR: [
		// ["PLY", { name: "Paris - Gare de Lyon" }],
		["PAZ", { name: "Paris - Gare d'Austerlitz" }],
	],
	NL: [
		["AMS", { name: "Amsterdam Centraal" }],
		["RTM", { name: "Rotterdam Centraal" }],
	],
	BE: [
		["ANR", { name: "Antwerp" }],
		["BRU", { name: "Brussels" }],
	],
	/** Eurostar NL / BE stations (ES suffix) */
	NL_EUROSTAR: [
		["AMSES", { name: "Amsterdam Centraal" }],
		["RTMES", { name: "Rotterdam Centraal" }],
	],
	BE_EUROSTAR: [
		["ANRES", { name: "Antwerp" }],
		["BRUES", { name: "Brussels" }],
	],
}

export const allTrainStationCodeMap = new Map<string, OriginInfo>(
	Object.values(trainStationsByCountry).flat()
)

const nlStationsWithEurostar = [
	...trainStationsByCountry.NL,
	...trainStationsByCountry.BE,
	...trainStationsByCountry.NL_EUROSTAR,
	...trainStationsByCountry.BE_EUROSTAR,
]

export const trainStationCodeMapByWebsiteDomain: Record<string, Map<string, OriginInfo>> = {
	"www.uk.travelski.com": new Map<string, OriginInfo>(trainStationsByCountry.UK),
	"www.travelski.com": new Map<string, OriginInfo>([...trainStationsByCountry.FR, ...trainStationsByCountry.BE]),
	"www.nl.travelski.com": new Map<string, OriginInfo>(nlStationsWithEurostar),
	"www.befr.yoonly.eu": new Map<string, OriginInfo>([
		...trainStationsByCountry.BE,
		...trainStationsByCountry.BE_EUROSTAR,
	]),
	"www.benl.yoonly.eu": new Map<string, OriginInfo>(nlStationsWithEurostar),
	"www.nl.yoonly.eu": new Map<string, OriginInfo>(nlStationsWithEurostar),
	"cse.travelski.com": new Map<string, OriginInfo>([...trainStationsByCountry.FR, ...trainStationsByCountry.BE]),
}
const country = getSiteFromDomain(window.location.hostname);
export const preferredTrainStationCodeMap = new Map<string, OriginInfo>(
	trainStationCodeMapByWebsiteDomain[country] ?? allTrainStationCodeMap
)

// Lookups must accept Eurostar and TNE stations on every site so
// PFPTT/PFTT can offer both operators. Domain preference is used only for defaults.
export const trainStationCodeMap = allTrainStationCodeMap
